var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FilterTypes } from './constants';
export var getActiveFilters = function (stringQuery) {
    var pattern = new RegExp('([a-zA-Z0-9_-]+)=([a-zA-Z0-9_-]+).([^&]+)&?');
    var queryParams = [];
    var _loop_1 = function () {
        var cap = pattern.exec(stringQuery);
        if (!cap) {
            return "break";
        }
        stringQuery = stringQuery.substring(cap[0].length);
        queryParams.push({
            key: cap[1],
            operation: FilterTypes.find(function (filter) { return filter.operation === cap[2]; }),
            value: cap[3],
        });
    };
    for (;;) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    return queryParams;
};
export var buildQueryString = function (queryArray) {
    var queryString = '';
    queryArray.forEach(function (query) {
        queryString += "".concat(query.key, "=").concat(query.operation.operation, ".").concat(query.value, "&");
    });
    return queryString;
};
export var formatColumnName = function (name) {
    if (name.charAt(0) === '_')
        name = name.replace('_', '');
    return name.replace(/_/g, ' ');
};
export var formatColumnType = function (type) {
    switch (type) {
        case 'string':
            return 'text';
        case 'integer':
            return 'number';
        case 'time':
            return 'date';
        case 'boolean':
            return 'True/False';
        case 'location':
            return 'location';
        default:
            return type;
    }
};
export var SEARCHABLE_COLUMN_TYPES = [
    'string',
    'richtext',
    'integer',
    'float',
    'time',
];
export var getSearchableColumns = function (fields) {
    if (fields === void 0) { fields = []; }
    return fields.filter(function (c) { return SEARCHABLE_COLUMN_TYPES.includes(c.type); }).map(function (c) { return c.name; });
};
export var getColumnNames = function (columns) {
    if (!columns || (columns && !columns.fields)) {
        return null;
    }
    return __spreadArray([], columns.fields.map(function (field) { return ({
        name: field.name,
        display: field.name,
        sortable: true,
        type: field.type,
        archived: field.archived,
    }); }), true);
};
